import type { Novidade } from './tipos';

export const novidadeNotificacoes: Novidade = {
  id: '2026-10-05-notificacoes',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'Notificações no sino e no celular',
      resumo: 'Os avisos dos módulos chegam ao sino na hora, e você escolhe o que recebe no sistema e no celular.',
      passos: [
        'O sino mostra os avisos mais recentes. Clique num aviso para abrir o registro.',
        'No item Notificações do menu (ou em Ver todas as notificações, no sino da barra superior), na aba Meus avisos, escolha o que receber no sistema e por push.',
        'Toque em Ativar notificações neste aparelho para receber push, mesmo com o app fechado.',
        'No histórico de um registro, use Mencionar alguém para avisar um colega.',
      ],
    },
    en: {
      titulo: 'Notifications on the bell and on your phone',
      resumo: 'Module notifications reach the bell right away, and you choose what you receive in the system and on your phone.',
      passos: [
        'The bell shows the latest notifications. Click one to open the record.',
        'In the Notifications menu item (or See all notifications, on the bell in the top bar), on the My notifications tab, choose what you receive in the system and by push.',
        'Tap Turn on notifications on this device to get push, even with the app closed.',
        'In the history of a record, use Mention someone to notify a coworker.',
      ],
    },
    es: {
      titulo: 'Notificaciones en la campana y en el celular',
      resumo: 'Los avisos de los módulos llegan a la campana al instante, y eliges qué recibir en el sistema y en el celular.',
      passos: [
        'La campana muestra los avisos más recientes. Haz clic en uno para abrir el registro.',
        'En el ítem Notificaciones del menú (o en Ver todas las notificaciones, en la campana de la barra superior), en la pestaña Mis avisos, elige qué recibir en el sistema y por push.',
        'Toca Activar notificaciones en este dispositivo para recibir push, incluso con la app cerrada.',
        'En el historial de un registro, usa Mencionar a alguien para avisar a un compañero.',
      ],
    },
  },
  imagens: [null, '/novidades/2026-10-05-notificacoes/central.webp', null, null],
  treinamento: { curso: 'novidades' },
  rota: '/conta/notificacoes',
};
